/** Hızlı tatil teklifi ekranının metni. Emoji, uzun tire ve yaklaşık işareti yok. */
export const HIZLI_METIN = {
  menu: 'Özel tatil paketi',
  baslik: 'Özel tatil paketi oluştur',
  atla: 'Sonuç tablosuna geç',
  // Müşteri ve talep
  talepBaslik: 'Müşteri ve talep',
  talepIpucu: 'Bilgiler CRM kaydından gelir',
  musteri: 'Müşteri (CRM kaydından)',
  musteriAra: 'Müşteri ara',
  musteriAraIpucu: 'Ad, telefon ya da e-posta (en az 2 harf)',
  musteriSec: 'Müşteri seçin',
  musteriYok: 'Müşteri seçilmedi. Önce CRM kaydından müşteriyi seçin.',
  musteriAramaHata: 'Müşteri araması tamamlanamadı. Yeniden deneyin.',
  musteriEkle: (ad: string) => `“${ad}” adlı kişiyi ekle`,
  musteriForm: {
    baslik: 'Yeni müşteri', ad: 'Ad', soyad: 'Soyad', telefon: 'Telefon', eposta: 'E-posta (isteğe bağlı)',
    adres: 'Fiziksel / fatura adresi (isteğe bağlı)', kimlik: 'TC kimlik numarası (isteğe bağlı)',
    kaydet: 'Kaydet ve seç', vazgec: 'Vazgeç', bekle: 'Kaydediliyor…',
    hata: 'Müşteri kaydedilemedi. Bilgileri kontrol edip yeniden deneyin.',
    mukerrer: 'Bu telefon veya e-posta ile kayıtlı müşteri var. Mevcut kaydı seçebilirsiniz.',
    denetimHata: 'Mevcut müşteri kontrolü tamamlanamadı. Yeniden deneyin.',
  },
  musteriBulunamadi: 'Aramaya uygun müşteri yok.',
  musteriDegistir: 'Müşteriyi değiştir',
  musteriYuklenemedi: 'Müşteri kaydı okunamadı. Yeniden deneyin.',
  uyrukChip: (k: string) => `Uyruk ${k}`,
  uyrukEksik: 'Uyruk eksik',
  uyrukEksikAcik: 'Uyruk seçilmedi. Fiyat uyruğa göre çekilir: Uyruk alanından seçin.',
  musteriKaydi: 'Müşteri kaydını aç',
  kanalWhatsapp: 'WhatsApp',
  tarihler: 'Konaklama tarihleri',
  hizliYaz: 'Hızlı yaz (yaşları doldurmaz)',
  hizliOrnek: '3 oda: 2+2çocuk, 2, 2',
  hizliHata: 'Hızlı yazım anlaşılmadı. Örnek: 3 oda: 2+2çocuk, 2, 2',
  hizliUygula: 'Odalara uygula',
  ekNotBaslik: 'Ek not (otel sayfasında ve özet satırında görünür, mesaja girmez)',
  ekNotIpucu: 'Örn. Kahvaltı yalnız Oda 1 fiyatına dahildir',
  paketNotIpucu: 'Ek not (gezi sayfasında görünür)',
  teklifNotuEtiket: 'Teklif notu (son sayfada Bilmeniz gerekenler listesine eklenir, mesaja girmez)',
  aracBaslik: 'Araç tipi (paketler araç sayısı kadar aracın toplamıdır)',
  aracOneri: 'en uygun seçenek',
  uyrukEtiket: 'Uyruk',
  uyrukSec: 'Seçin',
  ayEtiket: (n: number) => `${n}. çocuk, ay`,
  aySec: 'Ay (isteğe bağlı)',
  odaEkle: 'Oda ekle',
  odaOzeti: (oda: number, yetiskin: number, cocuk: number) => `${oda} oda, ${yetiskin} yetişkin, ${cocuk} çocuk`,
  odaOzetiGece: (gece: number) => `${gece} gece`,
  hizliYazimi: 'Hızlı yazım',
  // Oteller
  otellerBaslik: 'Oteller',
  otelSayisi: (n: number) => `${n} otel`,
  kisayolIpucu: 'Talep alanındayken',
  kisayolSon: 'fiyatları çeker',
  otelAra: 'Otel, şehir, bölge ya da otel no',
  otelAraYer: 'Dubai, JBR, Rixos veya 2001721',
  otelEkler: 'ekler',
  otelAramaBos: 'Aramanıza uygun otel yok.',
  otelAramaHata: 'Otel araması tamamlanamadı. Yeniden deneyin.',
  otelEklendi: (ad: string) => `${ad} listeye eklendi.`,
  otelZatenVar: (ad: string) => `${ad} zaten listede.`,
  otelLimit: 'En çok 12 otel eklenebilir.',
  otelYayinda: 'Yayında değil, teklif alınamaz',
  otelFiyatsiz: 'Fiyat alınamaz, teklif kapalı',
  otelKaldir: (ad: string) => `${ad} otelini listeden çıkar`,
  otelListesi: 'Seçili oteller',
  otelListesiBos: 'Henüz otel eklenmedi. Otel adı ya da numarasıyla arayın.',
  paketBaslik: '+ Gezi ve transfer paketi (tüm grup, her seçeneğin toplamına ayrı satır)',
  paketYok: 'Gezi ve transfer paketi: bu destinasyon için katalog paketi yok.',
  destinasyon: 'Destinasyon (otellerden dolar, düzenlenebilir)',
  destinasyonOtomatik: 'Otomatik doldur',
  baslikOnizleme: 'PDF başlığı',
  paketler: { TRANSFER: 'Transfer', DUBAI_TURU: 'Dubai turu', ABU_DABI_TURU: 'Abu Dabi turu', SAFARI_TURU: 'Safari turu', HELIKOPTER_TURU: 'Helikopter turu', GOKYUZUNDE_YEMEK: 'Gökyüzünde yemek', OZEL_YAT_TURU: 'Özel yat turu' },
  paketOperasyonNotu: 'Tarih ve saat satış sonrası operasyon tarafından planlanır',
  paketCocukCagri: 'Çocuk fiyatı için çağrı merkezimizi arayın',
  paketKisiBasi: 'Kişi başı fiyat, yetişkin sayısıyla çarpılır',
  // Özel yat: saat başı yat başı fiyat (28.10.2026)
  yat: {
    baslik: 'Özel yat turu',
    saat: 'Saat sayısı',
    saatIpucu: '1 ile 12 arası',
    saatHata: 'Saat sayısı 1 ile 12 arasında tam sayı olmalı.',
    boyut: 'Yat boyutu',
    boyutlar: { YAT_50FT: 'Majesty 50 ft Lüks Yat', YAT_70FT: 'Seahawk 70 ft Yat' },
    saatBasi: (t: string) => `${t} saat başı`,
    not: 'Fiyat yat başınadır, kişi sayısıyla değişmez. Toplam = saat x saat başı yat fiyatı.',
    toplam: (saat: number, t: string) => `${saat} saat: ${t}`,
  },
  paketFiyatYok: 'fiyat yok',
  paketFiyatYukleniyor: 'fiyat alınıyor',
  paketTumGrup: 'Tutar tüm grup içindir.',
  // Serbest kalemler (28.10.2026)
  kalem: {
    baslik: 'Serbest kalemler',
    ipucu: 'Satışçının kendi kalemleri: PDF\'te kendi satırıyla ve açıklamasıyla görünür, seçeneğin toplamına girer.',
    bos: 'Henüz serbest kalem yok.',
    ekle: 'Kalem ekle',
    limit: (n: number) => `En çok ${n} kalem eklenebilir.`,
    kaldir: (n: number) => `${n}. kalemi kaldır`,
    kaldirEtiket: 'Kaldır',
    baslikN: (n: number) => `Kalem ${n}`,
    ad: 'Ad',
    adIpucu: 'Örn. Şoförlü VIP araç tahsisi',
    aciklama: 'Açıklama (düz metin, en çok 600 karakter)',
    aciklamaSayac: (n: number, azami: number) => `${n} / ${azami}`,
    tutar: 'Tutar',
    tutarIpucu: 'Örn. 1.250,50',
    para: 'Para birimi',
    birim: 'Hesap',
    miktar: 'Adet',
    kapsam: 'Hangi seçeneğe',
    kapsamTum: 'Tüm seçeneklere',
    kapsamYalniz: (ad: string) => `Yalnız ${ad}`,
    kapsamYok: 'Bağlı seçenek teklifte işaretli değil',
    kdv: 'KDV notu',
    kdvIpucu: 'Örn. + %5 KDV',
    toplam: (t: string) => `Kalem toplamı: ${t}`,
    aedNotu: 'AED, USD\'ye 3,6725 sabit kurla çevrilir.',
    hata: { AD: 'Kalemin adı zorunlu.', TUTAR: 'Tutar sıfır ya da pozitif olmalı (örn. 1.250,50).', MIKTAR: 'Adet 1 ile 999 arasında tam sayı olmalı.', ACIKLAMA: 'Açıklama en çok 600 karakter olabilir.', SECENEK: 'Kalemin bağlı olduğu seçenek teklifte işaretli değil.', PARA: 'Bu para birimi teklifin para birimine çevrilemiyor.' },
    toplamTum: 'Tüm seçeneklere eklenen kalemler',
    salt: 'Eski sürümün kalemleri salt okunur gösteriliyor.',
  },
  // KDV notu (28.10.2026)
  kdv: {
    etiket: 'KDV notu (teklif geneli)',
    ipucu: 'Fiyatlar KDV hariç yazılır; PDF\'te "USD + %5 KDV" biçiminde görünür. Boş bırakırsanız KDV ifadesi çıkmaz.',
  },
  // Planlama ve işleyiş şablonları (28.10.2026)
  plan: {
    baslik: 'Planlama ve işleyiş',
    ipucu: 'PDF\'te "Planlama" ve "İşleyiş" başlıklarıyla ayrı blok olarak çıkar, mesaja girmez. Satır satır yazın; hazır metin ekleyip düzenleyebilirsiniz.',
    planlama: 'Planlama',
    isleyis: 'İşleyiş',
    sablonSec: 'Hazır metin ekle',
    sablonSecYok: 'Hazır metin seçin',
    sayac: (n: number, azami: number) => `${n} / ${azami}`,
  },
  // Katalogda olmayan otel (28.10.2026)
  manuel: {
    baslik: 'Katalogda olmayan oteller',
    ipucu: 'Aramada bulunmayan oteli kendiniz ekleyin: canlı fiyat çekilmez, tutar sizin yazdığınızdır. Fotoğraf yoktur.',
    ekle: 'Katalogda olmayan otel ekle',
    ad: 'Otel adı',
    sehir: 'Şehir',
    oda: 'Oda ya da süit adı',
    tutarTuru: 'Tutar türü',
    toplam: 'Tüm konaklamanın toplamı',
    gecelik: 'Gecelik',
    tutar: 'Tutar',
    tutarIpucu: 'Örn. 15.200,00',
    gece: 'Gece sayısı (1-60)',
    geceIpucu: (g: string) => `Boş bırakırsanız tarihlerden hesaplanır${g}`,
    geceTarihten: (n: number) => ` (${n} gece)`,
    geceYok: ' (tarih seçilmedi)',
    geceElle: (n: number) => `${n} gece (elle)`,
    para: 'Para birimi',
    iptal: 'İptal koşulu (serbest metin)',
    iptalIpucu: 'Örn. Varıştan 7 gün öncesine kadar ücretsiz iptal',
    ekNot: 'Ek not (otel sayfasında görünür, mesaja girmez)',
    kaydet: 'Listeye ekle',
    vazgec: 'Vazgeç',
    duzenle: (ad: string) => `${ad} otelini düzenle`,
    kaldir: (ad: string) => `${ad} otelini listeden çıkar`,
    teklife: (ad: string) => `${ad}, teklife ekle`,
    etiket: 'Elle eklendi',
    fiyatYok: 'Tarih seçilince hesaplanır',
    toplamMetni: (t: string) => `Toplam ${t}`,
    gecelikMetni: (g: string, gece: number) => `Gecelik ${g} x ${gece} gece`,
    hata: { AD: 'Otel adı zorunlu.', SEHIR: 'Şehir zorunlu.', ODA: 'Oda ya da süit adı zorunlu.', TUTAR: 'Tutar sıfırdan büyük olmalı (örn. 15.200,00).', GECE: 'Gece sayısı 1 ile 60 arasında tam sayı olmalı.', TARIH: 'Gecelik tutar için konaklama tarihlerini seçin.', IPTAL: 'İptal koşulu en çok 300 karakter olabilir.', NOT: 'Ek not en çok 600 karakter olabilir.' },
    eklendi: (ad: string) => `${ad} katalogda olmayan otel olarak eklendi.`,
    bolumOzet: (n: number) => `${n} elle eklenen otel`,
  },
  // Konaklama bölümleri (Musa kararı 26.10.2026)
  bolum: {
    ekle: '+ Konaklama bölümü ekle',
    etiket: (n: number) => `Bölüm ${n}`,
    sayi: (n: number) => `${n} bölüm`,
    sekmeler: 'Konaklama bölümleri',
    sil: 'Bölümü sil',
    silSor: 'Bu bölümün fiyatları ve seçimi silinsin mi?',
    silEvet: 'Evet, sil',
    silVazgec: 'Vazgeç',
    silindi: (n: number) => `Bölüm ${n} silindi.`,
    eklendi: (n: number) => `Bölüm ${n} eklendi.`,
    tarihler: (n: number) => `Bölüm ${n} tarihleri`,
    tarihlerBolumde: 'Tarihler her bölümde ayrı seçilir.',
    ortusme: (n: number) => `Bölüm ${n} girişi, önceki bölümün çıkışından önce olamaz. Tarihler ardışık olmalı.`,
    eksik: (n: number) => `Bölüm ${n} için giriş ve çıkış tarihini seçin.`,
    limit: 'En çok 3 konaklama bölümü eklenebilir.',
    tekSecim: 'Bu bölümde teklife tek seçenek girer.',
    sec: (ad: string, durum: string) => `${ad}, ${durum}, bu bölümün seçeneği`,
    planBaslik: 'Konaklama planı',
    planSatir: (n: number, ad: string, gece: number) => `Bölüm ${n}: ${ad}, ${gece} gece`,
    planPaket: 'Paketler',
    genelToplam: 'Genel toplam',
    genelKapsam: 'Bölüm seçimleri ve paketlerin toplamı.',
    bolumSecilmedi: (n: number) => `Bölüm ${n} için seçenek seçilmedi.`,
    paraFarkli: 'Bölümlerin para birimleri farklı: genel toplam alınamaz.',
    sekmeSecili: 'seçili',
    sekmeBos: 'seçim yok',
    tarihYok: 'tarih yok',
  },
  engelOrtusme: 'Fiyat çekmek için bölüm tarihlerindeki örtüşmeyi düzeltin.',
  // Fiyat çekme
  fiyatCek: 'Fiyatları çek',
  fiyatCekiliyor: 'Fiyatlar çekiliyor',
  fiyatYenidenCek: 'Fiyatları yeniden çek',
  tamamSayisi: (b: number, t: number) => `${b} / ${t} tamam`,
  otelBasinaSure: '(otel başına en çok 25 sn)',
  sonuclaraGit: (n: number) => `${n} fiyat hazır, sonuçlara git`,
  engelOtelYok: 'Fiyat çekmek için en az bir otel ekleyin.',
  engelTarih: 'Fiyat çekmek için giriş ve çıkış tarihini seçin.',
  engelUyruk: 'Fiyat çekmek için müşteri kaydında ülke kodu olmalı.',
  engelMusteri: 'Fiyat çekmek için müşteriyi seçin.',
  engelYas: 'Fiyat çekmek için bütün çocuk yaşlarını girin.',
  engelSurer: 'Fiyatlar çekiliyor.',
  engelSurum: 'Eski sürüm salt okunur. Taslağa dönüp çekin.',
  baslatilamadi: 'Fiyat işi başlatılamadı. Yeniden deneyin.',
  isKayboldu: 'Fiyat işi bulunamadı ya da süresi doldu. Fiyatları yeniden çekin.',
  // Sonuçlar
  sonuclarBaslik: 'Sonuçlar',
  sonuclarIpucu: 'İşaretlenenler teklife girer.',
  siraFiyat: 'Sıra: fiyata göre artan.',
  siraEkleme: 'Sıra: ekleme sırası. Hepsi gelince fiyata göre sıralanır, çekim sürerken sıra sabit kalır.',
  siraGuncelle: 'Fiyat sırasını güncelle',
  sonucBos: 'Henüz fiyat yok',
  sonucBosAcik: 'Otel ekleyip "Fiyatları çek" düğmesine basın. Fiyatlar burada, fiyata göre sıralı görünür.',
  sonucBosSayac: '0 otel',
  tabloAciklama: 'Otel fiyat sonuçları',
  kolonOnay: 'Teklife ekle',
  kolonOtel: 'Otel',
  kolonOda: 'Seçili oda kombinasyonu ve kahvaltı',
  kolonIptal: 'İptal ve geçerlilik',
  kolonToplam: (n: number) => `${n} oda toplamı`,
  kolonYenile: 'Yenile',
  enDusuk: 'En düşük',
  yeniGeldi: 'Yeni geldi',
  odaTipleri: (n: number) => `Oda tipleri (${n})`,
  yenile: (ad: string) => `${ad} fiyatını yenile`,
  yenidenDene: 'Yeniden dene',
  sec: (ad: string, durum: string) => `${ad}, ${durum}, teklife ekle`,
  secKapali: (ad: string, durum: string) => `${ad}, ${durum}, teklife eklenemez`,
  kahvaltiDahil: 'Kahvaltı dahil',
  iptalUcretsiz: (t: string) => `Ücretsiz iptal ${t}`,
  iptalYok: 'İadesiz',
  iptalBilinmiyor: 'İptal koşulu teyit edilir',
  gecerlilikKalan: (m: string) => `Geçerlilik ${m}`,
  gecerlilikYok: 'Geçerlilik bilinmiyor',
  suresiDoldu: 'Süresi doldu',
  guncelDegil: 'Güncel değil',
  odaUymuyor: (n: number) => `Oda ${n} uymuyor`,
  odaUymuyorAcik: (n: number) => `Oda ${n} için bu otelde uygun seçenek yok`,
  // Rozet metinleri
  durum: {
    bekliyor: 'Bekliyor',
    cekiliyor: 'Çekiliyor',
    hazir: 'Hazır',
    talep: 'Fiyat talebe bağlı',
    yok: 'Müsait değil',
    yanit: 'Yanıt alınamadı',
    sure: 'Süresi doldu',
    eski: 'Eski talep',
    uymuyor: 'Oda uymuyor',
  },
  talepAcik: 'Satış ekibi tedarikçiden teyit alır. Fiyat gelmeden seçilemez.',
  yokAcik: (gece: number, min: number | null) => (min !== null ? `Konaklama ${gece} gece, bu otel en az ${min} gece satıyor.` : 'Bu tarihlerde müsait oda yok.'),
  yokMin: (n: number) => `Müsait değil, ${n} gece min.`,
  yanitAcik: 'Ne oldu: otel zamanında yanıt vermedi. Ne yapmalı: yeniden dene.',
  eskiAcik: 'Tarih, oda ya da uyruk değişti. Bu fiyat artık geçerli değil: yeniden çekin.',
  // Hata ve sayım
  sayim: {
    hazir: (n: number) => `${n} fiyat hazır`,
    talep: (n: number) => `${n} fiyat talebe bağlı`,
    yok: (n: number) => `${n} otel müsait değil`,
    yanit: (n: number) => `${n} otelde yanıt alınamadı`,
    uymuyor: (n: number) => `${n} otelde oda uymuyor`,
    cekiliyor: (b: number, t: number) => `${t} otelin ${b} tanesi bitti`,
  },
  otelCekildi: (n: number, sure: string) => `${n} otel çekildi, ${sure} sürdü.`,
  hataBaslik: (n: number) => `${n} otelde yanıt alınamadı`,
  hataNeOldu: 'Ne oldu: 25 sn içinde yanıt alınamadı.',
  hataEtki: 'Diğer oteller etkilenmedi.',
  hataNeYapmali: 'Ne yapmalı:',
  yalnizOnuYenidenDene: 'Yalnız onu yeniden dene',
  tumHataBaslik: 'Hiçbir otelden fiyat alınamadı',
  tumHataAcik: 'Ne oldu: fiyat kaynağından yanıt gelmedi. Fiyat gösterilmiyor. Ne yapmalı: tümünü yeniden deneyin. Sürerse çağrı merkezini arayın.',
  tumunuYenidenDene: 'Tümünü yeniden dene',
  uygunYokBaslik: 'Uygun fiyat yok',
  uygunYokAcik: 'Hiçbir otelde seçilebilir fiyat yok. Tarihi kaydırın, geceyi artırın ya da otel ekleyin.',
  // Oda tipi şeridi
  seritBaslik: (ad: string) => `Oda tipleri, ${ad}`,
  seritToplam: (t: string) => `Satır toplamı ${t}`,
  seritAciklama: 'Varsayılan: konuğa uyan en düşük toplamlı kombinasyon. Kart fiyatı, belirtilen odaların tüm konaklama toplamıdır. Varsayılana göre fark bu tutara dahildir.',
  odaSecenekToplami: (adet: number) => adet > 1 ? `${adet} oda toplamı` : 'Oda toplamı',
  odaVarsayilanFarki: (tutar: string) => `Varsayılana göre ${tutar}`,
  varsayilanaDon: 'Varsayılana dön',
  kapat: 'Kapat',
  hepsineUygula: 'Hepsine uygula',
  hepsineUygulaKapali: 'Bu oda başka odalardan farklı düzende, hepsine uygulanamaz',
  odaBasligi: (ids: readonly number[], konuk: string) => `${ids.length === 1 ? `Oda ${ids[0]}` : `Oda ${ids.join(', ')}`}: ${konuk}`,
  varsayilan: 'Varsayılan',
  dahil: 'Dahil',
  kahvaltisiz: 'Kahvaltısız',
  /** Pansiyon etiketi; api/src/modules/hizli-teklif/oda-secenekleri.ts KAHVALTI_METNI ile aynı (test kilitler). */
  pansiyon: {
    KAHVALTI_DAHIL: 'Kahvaltı dahil',
    YALNIZ_ODA: 'Kahvaltısız',
    YARIM_PANSIYON: 'Yarım pansiyon',
    TAM_PANSIYON: 'Tam pansiyon',
    HER_SEY_DAHIL: 'Her şey dahil',
    BILINMIYOR: 'Pansiyon teyit edilir',
  },
  uygun: 'Uygun',
  ekYatak: 'Çocuk için ek yatak',
  uymuyor: 'Uymuyor',
  kapasiteBilinmiyor: 'Kapasite teyit edilir',
  bebekKaryola: 'bebek karyolası ücretsiz',
  alanM2: (n: number) => `${n} m2`,
  secenekFark: (f: string) => f,
  cocukKuralYok: 'Çocuk yaşı kuralı doğrulanmadı, otelden teyit edin.',
  alternatifBaslik: 'Aile odası yok, iki oda gerekir',
  alternatifAcik: (n: number) => `Oda ${n} için tek odada uygun seçenek yok.`,
  dagilimiUygula: 'Dağılımı uygula',
  dagilimTahmin: (t: string) => `Tahmini ${t}`,
  // Teklif özeti
  ozetBaslik: 'Teklif özeti',
  ozetSecenek: (n: number) => `${n} seçenek`,
  ozetAralik: 'Seçenek toplamı aralığı',
  ozetKapsam: (oda: string, para: string) => `${oda}. Her toplam tüm odaları kapsar. ${para}.`,
  ozetBos: 'Henüz işaretli seçenek yok. Sonuç tablosundan otelleri işaretleyin.',
  ozetKonaklama: 'Konaklama',
  ozetPaket: 'paket',
  ozetTamamlanmadi: 'Tamamlanmadı',
  ozetPaketFiyatsiz: (ad: string) => `${ad} paketinin fiyatı yok. Toplam tamamlanmadı, paket dahil sayılmaz.`,
  ozetKismi: 'Önizleme yalnız işaretlediğin otelleri içerir. Yeni gelen oteller kendiliğinden eklenmez.',
  ozetSureUyari: (ad: string, m: string) => `${ad} fiyatı ${m} içinde bitiyor. Göndermeden önce yenile.`,
  ozetSureDoldu: (ad: string) => `${ad} fiyatının süresi doldu. Teklif çıktısı kapandı.`,
  ozetSureKritik: (ad: string, m: string) => `${ad} fiyatı ${m} içinde bitiyor. Çıktı oluştururken onay istenir.`,
  pdfOlustur: 'PDF oluştur',
  mesajOlustur: 'Mesaj oluştur',
  kapali: 'Kapalı:',
  // Çıktı kapı nedenleri
  neden: {
    cekim: 'Fiyatlar çekiliyor. Bitince oluşturulabilir.',
    yas: 'Çocuk yaşı eksik. Yaşları girip fiyatları yeniden çekin.',
    eski: 'Talep değişti. Fiyatları yeniden çekin.',
    secimYok: 'Önce en az bir oteli işaretleyin.',
    sureDoldu: 'En az bir işaretli fiyatın süresi doldu. Yenileyin.',
    gecersiz: 'İşaretli otellerden birinin fiyatı geçersiz.',
    paket: 'Açık paketlerden birinin fiyatı yok. Fiyatı olan paketi seçin ya da paketi kapatın.',
    sonuc: 'Önce fiyatları çekin.',
    surum: 'Eski sürüm salt okunur.',
    tarih: 'Bölüm tarihleri örtüşüyor ya da eksik. Tarihleri düzeltin.',
    bolumSecim: 'Her bölümde tam bir seçenek seçin.',
    para: 'Bölümlerin para birimleri farklı. Genel toplam alınamıyor.',
    eskiMesaj: 'Seçim değişti. Mesajı yeniden oluşturun.',
    kalem: 'Serbest kalemlerden birinde eksik var. Ad, tutar, miktar ya da bağlı seçeneği düzeltin.',
    manuel: 'Katalogda olmayan otellerden birinde eksik var. Ad, şehir, oda, tutar ve tarihleri düzeltin.',
    yat: 'Özel yat için saat sayısını 1 ile 12 arasında girin.',
  },
  kritikOnay: 'Fiyatın süresi 2 dakikadan az kaldı. Yine de çıktı oluşturulsun mu?',
  kritikOnayEvet: 'Evet, oluştur',
  kritikOnayHayir: 'Vazgeç',
  // Mesaj
  mesajBaslik: 'WhatsApp mesaj taslağı',
  mesajBosAcik: 'Taslak, teklif oluşturulabilir olunca burada belirir.',
  mesajEtiket: 'Mesaj taslağı (düzenlenebilir)',
  mesajKopyala: 'Kopyala',
  mesajKopyalandi: 'Mesaj panoya kopyalandı.',
  mesajKopyalanamadi: 'Panoya yazılamadı. Metni seçip elle kopyalayın.',
  mesajPdfIndir: 'PDF indir',
  mesajSatisci: 'Göndermeyi satışçı yapar. Bu ekran mesajı kendiliğinden göndermez.',
  mesajGuncelDegil: 'Güncel değil: fiyat süresi doldu ya da talep değişti. Taslak salt okunur.',
  mesajTonu: 'Ton',
  tonlar: { SICAK: 'Sıcak', RESMI: 'Resmi', KISA: 'Kısa' },
  mesajHazir: 'Mesaj taslağı hazır.',
  mesajHata: 'Mesaj oluşturulamadı. Yeniden deneyin.',
  pdfHazir: 'PDF indirildi.',
  pdfHata: 'PDF oluşturulamadı. Yeniden deneyin.',
  uclarYok: 'Bu işlem için sunucu ucu henüz hazır değil.',
  // Sürümler
  surumlerBaslik: 'Önceki sürümler',
  surumChip: (no: number, z: string, ozet: string) => `v${no} ${z}, ${ozet}`,
  surumOtel: (n: number) => `${n} otel`,
  surumSecenek: (n: number) => `${n} seçenek`,
  tumSurumler: (n: number) => `Tüm sürümler (${n})`,
  surumSalt: 'Eski sürüm salt okunur açılır',
  surumAciklama: (no: number) => `v${no} salt okunur gösteriliyor.`,
  surumDon: 'Güncel taslağa dön',
  surumYok: 'Henüz kayıtlı sürüm yok. Her çekim yeni sürüm olarak kaydolur.',
  surumKaydedilemedi: 'Sürüm kaydedilemedi. Çıktı hazır; kayıt için PDF ya da mesajı yeniden oluşturun.',
  surumKaydedilemediCikti: (neden: string) => `Çıktı hazır ama sürüm sunucuya kaydedilemedi: ${neden} Taslak bu tarayıcıda saklandı.`,
  kayitliTaslakBaslik: (gun: string, saat: string) => `Bu müşteri için kayıtlı taslak var (${gun} ${saat})`,
  taslakFiyatUyarisi: 'Fiyatların geçerlilik süresi dolmuş olabilir; geri yükledikten sonra fiyatları yeniden çekin.',
  taslakGeriYukle: 'Kayıtlı taslağı geri yükle',
  taslakGeriYuklendi: 'Kayıtlı taslak geri yüklendi ve düzenlenebilir. Fiyatlar eski olabilir; Fiyatları çek ile yenileyin.',
  surumYuklenemedi: 'Sürüm açılamadı. Yeniden deneyin.',
  taslakMeta: (no: number, z: string) => `Taslak v${no}, ${z} kaydedildi`,
  // Duyuru (tek canlı bölge)
  duy: {
    basla: (n: number) => `Fiyatlar çekiliyor. ${n} otel sorulacak.`,
    ilerleme: (b: number, t: number) => `${t} otelden ${b} fiyat geldi.`,
    bitti: (ozet: string) => `Fiyatlar hazır. ${ozet}.`,
    hata: (ad: string) => `${ad} için yanıt alınamadı.`,
    sure: (ad: string, d: number) => `${ad} fiyatının süresi ${d} dakikadan az kaldı.`,
    sureDoldu: (ad: string) => `${ad} fiyatının süresi doldu. Teklif çıktısı kapandı.`,
    eski: 'Talep değişti. Eski fiyatlar geçersiz, çıktı kapandı.',
    sira: 'Fiyatlar fiyata göre sıralandı.',
    secim: (n: number) => `${n} otel teklifte.`,
    iptal: 'Fiyat çekimi iptal edildi.',
  },
  odaGaleriYok: 'Bu oda için doğrulanmış fotoğraf yok.',
  odaGaleri: (ad: string) => `${ad} fotoğrafları`,
  odaOncekiFoto: 'Önceki oda fotoğrafı',
  odaSonrakiFoto: 'Sonraki oda fotoğrafı',
  odaFiyatSayisi: (n: number) => `${n} fiyat seçeneği`,
  odaSayfalama: 'Oda tipi sayfaları',
  odaOnceki: 'Önceki 5 oda',
  odaSonraki: 'Sonraki 5 oda',
  odaSeciliyeGit: 'Seçili odaya git',
  odaSayfa: (sayfa: number, toplam: number, oda: number) => `${sayfa} / ${toplam} · ${oda} oda tipi`,
  // Genel
  yukleniyor: 'Yükleniyor',
  sa: 'sa',
  dk: 'dk',
  sn: 'sn',
  usd: 'USD',
} as const;
